export default __webpack_public_path__ + "static/media/close.0293103e.svg";